import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=09e3cdf4&"
import script from "./StarRating.vue?vue&type=script&lang=ts&"
export * from "./StarRating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports